import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class EmailRedirectGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // Check if initial redirect has already happened in this session
        const hasInitialRedirect = sessionStorage.getItem('hasInitialRedirect');

        if (!hasInitialRedirect) {
            try {
                const user = await this.authService.getUserProfile();

                if (user?.data?.getProfile?.email === 'jean-pierre@latouretpetit.be') {
                    // Only redirect if not trying to access admin routes
                    if (!state.url.startsWith('/admin')) {
                        sessionStorage.setItem('hasInitialRedirect', 'true');
                        await this.router.navigateByUrl('/admin/sales/list');
                        return false; // Prevent original navigation
                    }
                }
            } catch (error) {
                console.error('EmailRedirectGuard error:', error);
            }

            // Mark that we've checked for initial redirect
            sessionStorage.setItem('hasInitialRedirect', 'true');
        }

        return true; // Allow navigation
    }
}
